(() => {
  function init(root = document) {
    root.querySelectorAll('.gs-track,.gs-working-media__track,.glostrip-recipient-grid__items').forEach(track => {
      if (track.dataset.workingCarousel) return;
      const originals = [...track.children];
      if (originals.length < 2) return;
      track.dataset.workingCarousel = 'true';
      const mobile = window.matchMedia('(max-width:749px)');
      let index = 0;
      let clones = [];
      const nav = document.createElement('div');
      nav.className = 'gs-working-pagination';
      const prev = document.createElement('button');
      const next = document.createElement('button');
      const dots = document.createElement('div');
      dots.className = 'gs-working-dots';
      prev.type = next.type = 'button';
      prev.textContent = '‹'; next.textContent = '›';
      prev.setAttribute('aria-label','Previous card');
      next.setAttribute('aria-label','Next card');
      const buttons = originals.map((card,i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label',`Show card ${i + 1} of ${originals.length}`);
        dot.addEventListener('click',()=>go(i));
        dots.append(dot);
        return dot;
      });
      nav.append(prev,dots,next);
      track.after(nav);
      const reduce = window.matchMedia('(prefers-reduced-motion:reduce)');
      const center = card => card.offsetLeft - track.offsetLeft - (track.clientWidth-card.offsetWidth)/2;
      const mark = () => buttons.forEach((b,i)=>b.setAttribute('aria-current',String(i===index)));
      function go(i, smooth=true) {
        index = (i + originals.length)%originals.length;
        track.scrollTo({left:center(originals[index]),behavior:smooth&&!reduce.matches?'smooth':'instant'});
        mark();
      }
      function configure() {
        clones.forEach(c=>c.remove()); clones=[];
        if (mobile.matches) {
          for (const [card,leading] of [[originals.at(-1),true],[originals[0],false]]) {
            const clone=card.cloneNode(true);
            clone.setAttribute('aria-hidden','true');
            clone.inert=true;
            clone.removeAttribute('data-shopify-editor-block');
            clone.querySelectorAll('[id]').forEach(el=>el.removeAttribute('id'));
            if(leading)track.prepend(clone);else track.append(clone);
            clones.push(clone);
          }
        }
        requestAnimationFrame(()=>go(index,false));
      }
      prev.addEventListener('click',()=>go(index-1));
      next.addEventListener('click',()=>go(index+1));
      let timer;
      track.addEventListener('scroll',()=>{
        clearTimeout(timer);
        timer=setTimeout(()=>{
          const cards=[...track.children];
          const nearest=cards.reduce((a,b)=>Math.abs(center(a)-track.scrollLeft)<Math.abs(center(b)-track.scrollLeft)?a:b);
          const original=originals.indexOf(nearest);
          if(original>=0){index=original;mark();}
          else if(nearest===clones[0])go(originals.length-1,false);
          else if(nearest===clones[1])go(0,false);
        },160);
      },{passive:true});
      mobile.addEventListener('change',configure);
      new ResizeObserver(()=>go(index,false)).observe(track);
      configure();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
